import { useContext, useEffect, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { services } from "../../services/api";
import dayjs from "dayjs";
import MUIDataTable from "mui-datatables";
import GifLoader from "../../components/ui/gifLoader";
import { NotificacionContext } from "../../context/notificacion_context";
import swal from "sweetalert";
import Tooltip from "@mui/material/Tooltip";
import Modal from "@mui/material/Modal";

export const PagoEfectivo = () => {
  const { showNotification } = useContext(NotificacionContext);
  const colorUI = "#6f1d46";

  const [loader, setloader] = useState(false);
  const [state, setState] = useState([]);
  const [pdf, setPdf] = useState({
    pdfDocument: "",
    showModal: false,
  });
  const [loadingPdf, setLoadingPdf] = useState(true);

  const [filtros, setFiltros] = useState({
    fechaI: dayjs().format("YYYY-MM-DD"),
    fechaF: dayjs().format("YYYY-MM-DD"),
  });

  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    height: 900,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const options = {
    selectableRows: false,
    tableBodyHeight: "auto",
    textLabels: {
      body: {
        noMatch: "Lo sentimos, no hay coincidencias en la búsqueda",
        toolTip: "Clasificar",
        columnHeaderTooltip: (column) => `Clasificar por ${column.label}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtrar tabla",
      },
      filter: {
        all: "Todo",
        title: "Filtros",
        reset: "Restaurar",
      },
      viewColumns: {
        title: "Ver columnas",
        titleAria: "Mostrar/Ocultar columnas en la tabla",
      },
      selectedRows: {
        text: "columna(s) selecciona(as)",
        delete: "Eliminar",
        deleteAria: "Eliminar filas seleccionadas",
      },
    },
    responsive: "scrollMaxHeight",
    downloadOptions: {
      filename: "tablaSolicitudes.csv",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: false,
      },
    },
  };

  const columns = [
    {
      name: "lcaptura",
      label: "Referencia",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>{value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "fechaCreacion",
      label: "Fecha generación",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>{value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "fechaPago",
      label: "Fecha de cobro",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>{value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "importe",
      label: "Importe pagado",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>${value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "reciboSap",
      label: "No. recibo",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>{value}</p>
            </div>
          );
        },
      },
    },
    {
      name: "nombre",
      label: "Nombre",
      options: {
        customBodyRender: (value) => {
          return (
            <div className="w-100 d-flex justify-content-center align-items-center ">
              <p>{value}</p>
            </div>
          );
        },
      },
    },
  ];

  const handleFiltros = ({ target }) => {
    const { name, value } = target;
    setFiltros({ ...filtros, [name]: value });
  };

  const filtrarLineaCaptura = async () => {
    setloader(true);

    const bodyFechas = {
      fechaInicio: filtros.fechaI,
      fechaFin: filtros.fechaF,
    };

    const response = await services(
      "POST",
      "lineas-captura-filtradas",
      bodyFechas
    );

    if (response.status === 200) {
      setState(response.data);
    } else {
      showNotification(
        "error",
        "Acción No Exitosa!",
        "Ocurrio un error al filtrar",
        null,
        4
      );
    }

    setloader(false);
  };

  const generarLineaCaptura = async () => {
    setloader(true);

    const bodySend = {
      fechaInicio: filtros.fechaI,
      fechaFin: filtros.fechaF,
    };

    const response = await services(
      "POST",
      "generar-referencia-global",
      bodySend
    );

    const { data } = response;

    if (response.status === 200) {
      showNotification(
        "success",
        "Acción Exitosa!",
        "Se ha generado la línea de captura global",
        null,
        4
      );
      setPdf({ ...pdf, pdfDocument: data.data.pdf, showModal: true });
      filtrarLineaCaptura();
    } else {
      showNotification(
        "error",
        "Acción No Exitosa!",
        "Ocurrio un error al generar la línea de captura global",
        null,
        4
      );
    }
    setloader(false);
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      filtrarLineaCaptura();
    }

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      {loader ? <GifLoader /> : null}
      <div className="container my-3">
        <div className="border-bottom--guinda text-big mb-2 text-bold">
          <h2>Generación de referencia global</h2>
        </div>

        <div
          style={{ columnGap: 15, rowGap: 20 }}
          className="d-flex flex-wrap flex-row justify-content-center m-2 my-5"
        >
          <TextField
            InputLabelProps={{ shrink: true }}
            onChange={handleFiltros}
            value={filtros.fechaI}
            name="fechaI"
            label="Fecha Inicio"
            size="small"
            type="date"
          />
          <TextField
            InputLabelProps={{ shrink: true }}
            onChange={handleFiltros}
            value={filtros.fechaF}
            name="fechaF"
            label="Fecha Fin"
            size="small"
            type="date"
          />
          <Button
            startIcon={<SearchIcon />}
            onClick={filtrarLineaCaptura}
            variant="contained"
            sx={{
              backgroundColor: "#6f1d46",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#6f1d46",
                boxShadow: "inset 0 0 0 1000px rgba(255,255,255,0.1)",
              },
            }}
          >
            Consultar
          </Button>

          <Tooltip
            title={
              !state.data || state.data.length === 0
                ? "No hay información para generar una línea de captura global"
                : ""
            }
          >
            <span>
              <Button
                disabled={!state.data || state.data.length === 0}
                startIcon={<ReceiptLongIcon />}
                onClick={() => {
                  swal({
                    title: "¡Atención!",
                    text: "¿Desea generar la línea de captura global?",
                    icon: "info",
                    buttons: ["Cancelar", "Continuar"],
                    confirmButton: true,
                  }).then((isSelected) => {
                    if (isSelected) {
                      generarLineaCaptura();
                    }
                  });
                  document.querySelector(
                    ".swal-button--confirm"
                  ).style.backgroundColor = colorUI;
                }}
                variant="contained"
                sx={{
                  backgroundColor: "#6f1d46",
                  "&:hover": {
                    backgroundColor: "#6f1d46",
                    boxShadow: "inset 0 0 0 1000px rgba(255,255,255,0.1)",
                  },
                }}
              >
                Generar línea de captura global
              </Button>
            </span>
          </Tooltip>
        </div>

        <MUIDataTable
          style={{ overflow: "hidden" }}
          data={state.data}
          columns={columns}
          options={options}
        />

        <Box display="flex" justifyContent="flex-end" mt={2} px={2}>
          <Typography variant="body1" fontWeight="bold">
            Total de referencias: {state.cantitdad}
          </Typography>
          <Typography variant="body1" fontWeight="bold" ml={4}>
            Importe total: ${state.total}
          </Typography>
        </Box>
      </div>

      {pdf.showModal ? (
        <Modal
          open={pdf.showModal}
          onClose={() => setPdf({ ...pdf, showModal: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleModal}>
            {loadingPdf && (
              <div className="d-flex justify-content-center align-items-center py-3">
                <p>Cargando PDF...</p>
              </div>
            )}

            <iframe
              src={pdf.pdfDocument}
              width="100%"
              height="88%"
              title="PDF"
              onLoad={() => setLoadingPdf(false)}
            ></iframe>

            <div className="d-flex justify-content-end mt-2">
              <Button
                sx={{
                  backgroundColor: "#6f1d46",
                }}
                variant="contained"
                onClick={() => setPdf({ ...pdf, showModal: false })}
              >
                Cerrar
              </Button>
            </div>
          </Box>
        </Modal>
      ) : null}
    </>
  );
};
